import { graphql } from '@eluve/graphql.tada';

export const userInterstitialFlowFragment = graphql(`
  fragment UserInterstitialFlow on UserInterstitialFlows @_unmask {
    __typename
    id
    flowName
    completedAt
    skippedAt
    data
  }
`);

// Root (query_root) fragment for the collection so we can update it via cacheUtils.updateFragment
export const userInterstitialFlowsRootFragment = graphql(
  `
    fragment UserInterstitialFlows on query_root @_unmask {
      userInterstitialFlows {
        ...UserInterstitialFlow
      }
    }
  `,
  [userInterstitialFlowFragment],
);

export const getUserFlowCompletionsQuery = graphql(
  `
    query getUserFlowCompletions {
      ...UserInterstitialFlows
    }
  `,
  [userInterstitialFlowsRootFragment],
);

export const completeInterstitialFlowMutation = graphql(
  `
    mutation completeInterstitialFlow(
      $flowName: InterstitialFlowTypesEnum!
      $data: jsonb
    ) {
      insertUserInterstitialFlowsOne(
        object: { flowName: $flowName, completedAt: "now()", data: $data }
      ) {
        ...UserInterstitialFlow
      }
    }
  `,
  [userInterstitialFlowFragment],
);

export const skipInterstitialFlowMutation = graphql(
  `
    mutation skipInterstitialFlow($flowName: InterstitialFlowTypesEnum!) {
      insertUserInterstitialFlowsOne(
        object: { flowName: $flowName, skippedAt: "now()" }
      ) {
        ...UserInterstitialFlow
      }
    }
  `,
  [userInterstitialFlowFragment],
);
